import { isNullOrEmpty } from "../../../../../../../../../Common/TypingUtils";

export function extractOKTMO8Symbols(oktmo: string | undefined): string | undefined {
    if (isNullOrEmpty(oktmo)) {
        return undefined;
    }
    return oktmo.substring(0, 8);
}
